export default "__VITE_ASSET__qyNPepKY__"